import { useEffect, useState, useMemo } from "react";
import C from "Constants";
import { HeadingText } from "components/TextTranslationContainer";
import { RadioOption } from "components/RadioButton";
import usePaymentOptionSelection, {
  DineInPaymentOptions as Options,
} from "./usePaymentOptionSelection";
import { useSelector } from "react-redux";

const DineInAvailablePaymentOptions = ({
  setSelectedPaymentOptions,
  validStorePaymentOptions,
  selectedPaymentOptions,
  isSplitInProgress,
}) => {
  const { handleOptionChange } = usePaymentOptionSelection({
    setSelectedPaymentOptions: setSelectedPaymentOptions,
  });

  const { ordered, openSplitBill, isPayNow } = useSelector((state) => state?.order);
  const { orderId: existingOrder, cart } = useSelector((state) => state?.cart);

  const [paymentOptions, setPaymentOptions] = useState([]);
  const [selectedPaymentOption, setSelectedPaymentOption] = useState(null);

  const isPayLater = useMemo(() => {
    return validStorePaymentOptions?.find(
      (option) => option?.paymentType === C.PAY_LATER,
    );
  }, [validStorePaymentOptions]);

  const getPaymentOptions = () => {
    const options = [];
    if(existingOrder || !isPayLater || isPayNow || isSplitInProgress || ordered?.splitBills?.length > 0){
      options.push(Options["Complete Payment Now"]);
    }
    if ((isPayLater && !openSplitBill && !isSplitInProgress && !isPayNow) && cart?.length > 0) {
      options.push(Options["Dine First, Pay Later"]);
    }
    setPaymentOptions(options);
  }

  const getSelectedPaymentOption = () => {
    const isCompletePayment =
      (isSplitInProgress || ordered?.splitBills?.length > 0 || openSplitBill || isPayNow || existingOrder) && cart?.length === 0;
    const option = isCompletePayment
      ? Options["Complete Payment Now"]
      : isPayLater
        ? Options["Dine First, Pay Later"]
        : Options["Complete Payment Now"];
    setSelectedPaymentOption(option);
  }

  useEffect(() => {
    getPaymentOptions();
    getSelectedPaymentOption();
  }, [isPayLater, openSplitBill, existingOrder, isSplitInProgress, isPayNow, ordered]);

  useEffect(() => {
    if (selectedPaymentOption) {
      handleOptionChange(selectedPaymentOption);
    }
  }, [selectedPaymentOption]);

  return (
    <div className="w-full mb-6 flex flex-col gap-6">
      <HeadingText text={"Choose When to Pay"} />
      <div className="flex flex-col gap-1">
        {paymentOptions?.map((option) => {
          return (
            <RadioOption
              key={option?.id}
              label={option?.title}
              value={option?.id}
              onClick={() => {
                handleOptionChange(option);
              }}
              disabled={paymentOptions?.length === 1 || openSplitBill}
              checked={selectedPaymentOptions?.id === option?.id}
            />
          );
        })}
      </div>
    </div>
  );
};

export default DineInAvailablePaymentOptions;
